export function isIContext(possible) {
    if (possible === null || typeof possible !== 'object' || Array.isArray(possible)) {
        return false;
    }
    for (const value of Object.values(possible)) {
        const type = typeof value;
        if (type === 'undefined' || type === 'string' || type === 'number' || isIContext(value)) {
            continue;
        }
        return false;
    }
    return true;
}
export default isIContext;
//# sourceMappingURL=isIContext.js.map